import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Help(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), React.createElement("path", {
    d: "M9.5 16a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM7.396 6.488a1.025 1.025 0 01-.796-.046 1.051 1.051 0 01-.541-.6 1.042 1.042 0 01.046-.803A3.613 3.613 0 019.345 3h.021c1.961.02 3.56 1.562 3.632 3.502a3.585 3.585 0 01-2.464 3.509s-.105.037-.105.099v.838c0 .582-.476 1.052-1.062 1.052a1.056 1.056 0 01-1.061-1.051v-.84a2.225 2.225 0 011.546-2.09 1.498 1.498 0 001.026-1.465 1.542 1.542 0 00-1.526-1.457 1.51 1.51 0 00-1.35.856 1.058 1.058 0 01-.606.535zM9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9z"
  }));
}

export { Help };
//# sourceMappingURL=Help.js.map